import Market from "model/market";
import Calendar from "model/calendar";
import Territory from "model/political/territory";
import { random } from "lib/util/rng";

class City {
  static Generosity = { ...Market.Generosity };
  static StatusInTown = {
    Fringe: "Fringe",
    Familiar: "Familiar",
    Dominant: "Dominant",
  };

  constructor({ position, cityName, territory, step, terrName }) {
    this.position = position;
    this.name = cityName;
    this.territory = territory;
    this.isCapital = !!terrName;
    this.step = step;
    this.influence = 0;
    this.intimidation = 0;
    this.respect = 0;
    this.statusInTown = City.StatusInTown.Fringe;
    // Seeded: a town's disposition is a property of the world, drawn once at Political.init, so it
    // belongs with the map rather than with the run. TODO: Situational?
    this.generosity =
      Math.floor(random() * Object.keys(City.Generosity).length) * 10;
    this.market = new Market({
      season: Calendar.Spring,
      generosity: this.generosity,
      friendliness: Territory.Attitude.Neutral,
      supplyDemandFactor: 1, // Default value, could be adjusted based on events
    });
  }

  attitude(charisma) {
    return this.territory.attitude(charisma);
  }

  calculateStatus() {
    const influence = this.influence;
    const intimidation = this.intimidation;
    const respect = this.respect;

    // Since we know the max value is 100, we can simplify by checking absolute values
    const thresholds = { dominant: 97, familiar: 85 }; // Example thresholds

    // Check if any value meets the criteria for Dominant status
    if (
      influence >= thresholds.dominant || intimidation >= thresholds.dominant ||
      respect >= thresholds.dominant
    ) {
      return City.StatusInTown.Dominant;
    } // Check for Familiar status
    else if (
      influence >= thresholds.familiar ||
      intimidation >= thresholds.familiar ||
      respect >= thresholds.familiar
    ) {
      return City.StatusInTown.Familiar;
    } // Default to Fringe if no other criteria are met
    else {
      return City.StatusInTown.Fringe;
    }
  }

  updateStatusMetrics({ influence = 0, intimidation = 0, respect = 0 }) {
    this.influence = Math.max(
      0,
      Math.min(100, Math.round((this.influence + influence) * 10) / 10),
    );
    this.intimidation = Math.max(
      0,
      Math.min(100, Math.round((this.intimidation + intimidation) * 10) / 10),
    );
    this.respect = Math.max(
      0,
      Math.min(100, Math.round((this.respect + respect) * 10) / 10),
    );
    this.statusInTown = this.calculateStatus();
    //this.updateMarketAndAttitude();

    return this.statusInTown;
  }

  getStatus() {
    return this.statusInTown;
  }

  updateMarket(party, political, calendar) {
    this.market.update({
      season: calendar.season(),
      generosity: this.generosity,
      friendliness: party.attitude(political),
      supplyDemandFactor: 1, // Default value, could be adjusted based on events
    });
  }

  getMarket() {
    return this.market;
  }
}

export default City;
